import { memo } from "react";
import { Text } from "src/components/elements/typography/Text";
import { MypageSectionTitle } from "../../mypageSectionTitle";
import styles from "./styles.module.scss";

export const MypageDeleteAccountBody = memo(() => {
  return (
    <main>
      <MypageSectionTitle>アカウント削除</MypageSectionTitle>
      <section className={styles.container}>
        <Text className={styles.text}>
          アカウント削除はアプリのマイページより実施してください。
        </Text>
      </section>
    </main>
  );
});
